interface Props {
  names: string[];
}

/** The "Preferred neighborhoods: N" rows (Figma preview + player details): cityscape + name. */
export default function NeighborhoodList({ names }: Props) {
  return (
    <div className="flex flex-col gap-ds-md">
      {names.map((name) => (
        <div key={name} className="flex items-center gap-ds-sm">
          <img src="/images/find/cityscape.svg" alt="" className="h-8 w-8 shrink-0" />
          <span className="typography-product-card-title-mobile text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            {name}
          </span>
        </div>
      ))}
    </div>
  );
}
